/* ============================================================
   CROCK'N CLE — BASE JAVASCRIPT
   Nav interactions, mobile menu, cart, scroll animations
   ============================================================ */

(function() {
  'use strict';

  /* ── MOBILE MENU ─────────────────────────────── */
  var mobileToggle = document.getElementById('mobileMenuToggle');
  var mobileMenu   = document.getElementById('mobileMenu');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', function() {
      var isOpen = mobileMenu.classList.toggle('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen);
      mobileMenu.setAttribute('aria-hidden', !isOpen);
      document.body.classList.toggle('nav-open', isOpen);
    });
  }

  /* ── DROPDOWN NAV — KEYBOARD SUPPORT ─────────── */
  var dropdownBtns = document.querySelectorAll('.site-nav__btn');
  dropdownBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      // Close all first
      dropdownBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
      this.setAttribute('aria-expanded', !expanded);
    });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.site-nav__link')) {
      dropdownBtns.forEach(function(b) { b.setAttribute('aria-expanded', 'false'); });
    }
  });

  /* ── SEARCH TOGGLE ────────────────────────────── */
  var searchToggle = document.getElementById('searchToggle');
  if (searchToggle) {
    searchToggle.addEventListener('click', function() {
      // Shopify predictive search or custom search modal
      var searchModal = document.getElementById('searchModal');
      if (searchModal) {
        searchModal.classList.toggle('is-open');
      }
    });
  }

  /* ── CART COUNT UPDATE ────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = document.getElementById('cartCount');
        if (count) {
          count.textContent = cart.item_count;
          count.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      });
  }
  updateCartCount();

  /* ── FADE-IN ON SCROLL ───────────────────────── */
  var fadeEls = document.querySelectorAll('.fade-in');
  if ('IntersectionObserver' in window && fadeEls.length) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    fadeEls.forEach(function(el) { observer.observe(el); });
  } else {
    // Fallback — just show all
    fadeEls.forEach(function(el) { el.classList.add('is-visible'); });
  }

  /* ── STICKY NAV SHADOW ───────────────────────── */
  var siteNav = document.querySelector('.site-nav');
  if (siteNav) {
    window.addEventListener('scroll', function() {
      siteNav.classList.toggle('is-scrolled', window.scrollY > 10);
    });
  }

  /* ── ADD TO CART — AJAX ──────────────────────── */
  window.CrocknCLE = window.CrocknCLE || {};

  window.CrocknCLE.addToCart = function(variantId, quantity, callback) {
    quantity = quantity || 1;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(item) {
      updateCartCount();
      if (typeof callback === 'function') callback(null, item);
    })
    .catch(function(err) {
      if (typeof callback === 'function') callback(err);
    });
  };

  /* ── FORM SUCCESS MESSAGES ───────────────────── */
  var forms = document.querySelectorAll('[data-success-message]');
  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      var successMsg = this.getAttribute('data-success-message');
      if (successMsg) {
        var msgEl = document.createElement('p');
        msgEl.className = 'form-success';
        msgEl.textContent = successMsg;
        this.parentNode.insertBefore(msgEl, this.nextSibling);
      }
    });
  });

  /* ── PRODUCT CARD — QUICK VIEW HOVER ─────────── */
  // Add hover class to product cards for CSS transitions
  document.querySelectorAll('.product-card').forEach(function(card) {
    card.addEventListener('mouseenter', function() {
      this.classList.add('is-hovered');
    });
    card.addEventListener('mouseleave', function() {
      this.classList.remove('is-hovered');
    });
  });

})();
